import { IoIosArrowForward } from 'react-icons/io';

const Accordion = ({ title, description, icon, isOpen, onClick, list, para, img }) => {
  return (
    /* border switches colour when open */
    <div
      className={`py-4 border-b-2 transition-colors duration-300 ${isOpen ? 'border-[#2196F3]' : 'border-[#212121]'
        }`}
    >
      <div className="flex items-center justify-between cursor-pointer" onClick={onClick}>
        <div className="flex items-start justify-start space-x-4">
          {/* <img src={icon} alt="" className="h-8 w-8" /> */}
          <h3 className={`font-bold md:text-xl text-lg text-left transition-colors duration-300 ${isOpen ? 'text-[#2196F3]' : 'text-[#212121]'}`}>
            {title}
          </h3>
        </div>
        <IoIosArrowForward size={24} className={`transform transition-transform duration-300 ${isOpen ? 'rotate-90 text-[#2196F3]' : ''}`} />
      </div>

      {isOpen && (
        <div className="space-y-2 pt-4 textblack">
          <p className="text-base text-left">{description}</p>
          <p className="text-base text-left pt-3 pb-2">{para}</p>
          {Array.isArray(list) && (
            <ul className="list-disc pl-10 text-left">
              {list.map((item, index) => (
                <li key={index} className="text-base text-[#212121]">
                  {item}
                </li>
              ))}
            </ul>
          )}
          {img && (
            <div className="flex items-center justify-center w-full block lg:hidden py-4">
              <img data-aos="fade-left" src={img} alt="Accordion Visual" className="z-0" />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Accordion;
